import { render } from "./pnc_head.vue?vue&type=template&id=ace51d8e&scoped=true"
import script from "./pnc_head.vue?vue&type=script&lang=js"
export * from "./pnc_head.vue?vue&type=script&lang=js"

import "./pnc_head.vue?vue&type=style&index=0&id=ace51d8e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace51d8e"]])

export default __exports__